import { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import PropTypes from 'prop-types'

// Context
import { NavigationContext } from '../../context/NavigationContext'
import { UserContext } from '../../context/UserContext'

const OverviewExplainer = (props) => {
  const { data, modifiers } = props

  // Context
  const navigationContext = useContext(NavigationContext)
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''
  const rawText = typeof data.text === 'string' ? data.text : data.text?.html
  const textContent = rawText ? rawText.replace(/<\/?p[^>]*>/g, '') : false

  // State Classes
  const openClass = 'is-expanded'

  // States
  const [expandState, setExpandState] = useState(false)

  useEffect(() => {
    if (navigationContext.routeChange === true) setExpandState(false)
  }, [navigationContext.routeChange])

  const createMarkup = (copy) => ({ __html: copy })

  return (
    <div className={`OverviewExplainer${modifierClasses}${expandState ? ` ${openClass}` : ''}`}>
      <div className="OverviewExplainer-inner">
        {textContent && (
          <>
            <p className="OverviewExplainer-description">
              <span className="OverviewExplainer-content" dangerouslySetInnerHTML={createMarkup(textContent)}></span>
              <span className="OverviewExplainer-contract" onClick={() => setExpandState(false)}>
                &nbsp;<em>{t('OVERVIEWEXPLAINER__BTN_COLLAPSE')}</em>
              </span>
            </p>
            <span className="OverviewExplainer-expand" onClick={() => setExpandState(true)}>
              <em>{t('OVERVIEWEXPLAINER__BTN_READMORE')}</em>
            </span>
          </>
        )}
      </div>
    </div>
  )
}

OverviewExplainer.propTypes = {
  data: PropTypes.object,
  modifiers: PropTypes.array
}

export default OverviewExplainer
